import { Grid, Typography, Switch, Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import SubCard from "ui-component/cards/SubCard";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import {
  PersonOutline,
  Transgender,
  PhoneIphone,
  EmailOutlined,
  SchoolOutlined,
  ClassOutlined,
  AccountTreeOutlined,
  WorkOutline,
  LocationOnOutlined,
  EditOutlined,
} from "@mui/icons-material";

const PersonalDetailsCard = ({
  alumniDetails,
  handleNavigate,
  IsConnection,
  handleNavigateWorkingStatus,
}) => {
  const [privicyDetails, setPrivicyDetails] = useState([]);
  const [emailSwitch, setEmailSwitch] = useState(false);
  const [phoneSwitch, setPhoneSwitch] = useState(false);

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const getPrivicyDetails = async () => {
    try {
      const response = await axios.get(
        `/v1/settings/profile/get/by-id?userId=${localStorage.getItem(
          "userId"
        )}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );

      setPrivicyDetails(response?.data?.data);

      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  const addressParts = [
    alumniDetails?.address?.city,
    alumniDetails?.address?.state,
    alumniDetails?.address?.country,
  ].filter(Boolean);

  const updatePrivacySettings = async (
    emailVisible,
    phoneVisible,
    settingType,
    isPublic
  ) => {
    try {
      const response = await axios.get(
        `/v1/settings/profile?emailVisible=${emailVisible}&phoneVisible=${phoneVisible}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );

      const visibilityStatus = isPublic ? "visible to others" : "kept private";

      dispatch(
        openSnackbar({
          open: true,
          message: `Your ${settingType} is now ${visibilityStatus}.`,
          variant: "alert",
          alert: { color: "success" },
          close: false,
        })
      );
      generateTimeStamp();
    } catch (error) {
      console.error("Failed to update privacy settings:", error);
      dispatch(
        openSnackbar({
          open: true,
          message: `Unable to update your ${settingType}. Please try again.`,
          variant: "alert",
          alert: { color: "error" },
          close: false,
        })
      );
    }
  };
  const formattedAddress = addressParts.join(", ");

  //   // const fetchScrapedAbout = async () => {
  //   //   try {
  //   //     const publicProfileUrl = 'https://www.linkedin.com/in/chhavisrivastva/';
  //   //     const res = await fetch(
  //   //       `http://localhost:5000/linkedin/about-scrape?url=${encodeURIComponent(publicProfileUrl)}`
  //   //     );
  //   //     const data = await res.json();
  //   //     console.log(data, "Data>>>>>>>>>>")
  //   //     setAbout(data.about);
  //   //   } catch (err) {
  //   //     console.error('Error scraping about section:', err);
  //   //   }
  //   // };

  //   fetchProfile();
  //   // fetchScrapedAbout();
  // }, [token]);

  useEffect(() => {
    getPrivicyDetails();
  }, []);
  useEffect(() => {
    setPhoneSwitch(privicyDetails?.phone);
    setEmailSwitch(privicyDetails?.email);
  }, [privicyDetails]);

  useEffect(() => {
    generateTimeStamp();
  }, []);

  return (
    <>
      <SubCard
        sx={{
          p: 1,
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "0.5em",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ffffff",
          },
        }}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#245081", fontSize: "18px" }}>
                Personal Details
              </span>
            </Typography>
          </div>
        }
        secondary={
          <>
            {!IsConnection && (
              <>
                <div style={{ cursor: "pointer" }}>
                  <img
                    height="20px"
                    onClick={() => handleNavigate(alumniDetails?.id)}
                    alt="icon"
                    src="/assets/images/icons/editIcon.svg"
                  />
                </div>
              </>
            )}
          </>
        }
      >
        <Box
          sx={{
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          {[
            {
              label: "Name",
              value: alumniDetails?.name,
              icon: <PersonOutline sx={{ color: "primary.main", mr: 1 }} />,
            },
            {
              label: "Gender",
              value: alumniDetails?.gender,
              icon: <Transgender sx={{ color: "secondary.main", mr: 1 }} />,
            },
            {
              label: "Phone",
              value: alumniDetails?.phoneNo,
              icon: <PhoneIphone sx={{ color: "success.main", mr: 1 }} />,
              switch: !IsConnection && (
                <SwitchWithLabel
                  checked={phoneSwitch}
                  onChange={(e) => {
                    const newValue = e.target.checked;
                    setPhoneSwitch(newValue);
                    updatePrivacySettings(
                      emailSwitch,
                      newValue,
                      "Phone Number",
                      newValue
                    );
                  }}
                />
              ),
            },
            {
              label: "Email",
              value: alumniDetails?.email,
              icon: <EmailOutlined sx={{ color: "warning.main", mr: 1 }} />,
              switch: !IsConnection && (
                <SwitchWithLabel
                  checked={emailSwitch}
                  onChange={(e) => {
                    const newValue = e.target.checked;
                    setEmailSwitch(newValue);
                    updatePrivacySettings(
                      newValue,
                      phoneSwitch,
                      "Email Address",
                      newValue
                    );
                  }}
                />
              ),
            },
            {
              label: "Year of Passing",
              value: alumniDetails?.batch?.tag,
              icon: <SchoolOutlined sx={{ color: "info.main", mr: 1 }} />,
            },
            {
              label: "Class",
              value: alumniDetails?.programs?.name,
              icon: <ClassOutlined sx={{ color: "success.main", mr: 1 }} />,
            },
            {
              label: "Campus",
              value: alumniDetails?.institutionsBranch?.name,
              icon: (
                <AccountTreeOutlined sx={{ color: "secondary.main", mr: 1 }} />
              ),
            },
            {
              label: "Employment Status",
              value: alumniDetails?.careerStatus
                ? alumniDetails.careerStatus === "Higher_Education"
                  ? "Higher Education"
                  : alumniDetails.careerStatus === "Self_Employment"
                    ? "Self Employed"
                    : alumniDetails.careerStatus === "Working"
                      ? "Employed"
                      : ""
                : "-----",
              icon: <WorkOutline sx={{ color: "info.main", mr: 1 }} />,
              action: !IsConnection && alumniDetails?.careerStatus && (
                <IconButton
                  size="small"
                  onClick={() => handleNavigateWorkingStatus(alumniDetails?.id)}
                  sx={{ ml: 1 }}
                >
                  <EditOutlined fontSize="small" />
                </IconButton>
              ),
            },
            {
              label: "Address",
              value: formattedAddress,
              icon: <LocationOnOutlined sx={{ color: "error.main", mr: 1 }} />,
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                borderBottom: index !== 8 ? "1px solid" : "none",
                borderColor: "divider",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
                transition: "background-color 0.2s ease",
              }}
            >
              {/* Icon Column */}
              <Box sx={{ width: 40 }}>{item.icon}</Box>

              {/* Label Column */}
              <Typography
                sx={{
                  minWidth: 180,
                  fontWeight: 600,
                  color: "text.secondary",
                }}
              >
                {item.label}
              </Typography>

              {/* Value Column */}
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  minHeight: 40, // Ensure consistent height even when empty
                }}
              >
                <Typography variant="body1" sx={{ flex: 1 }}>
                  {item.value || "-----"}
                </Typography>

                {/* Switch or Action */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    ml: 2,
                  }}
                >
                  {item.switch}
                  {item.action}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </SubCard>
    </>
  );
};

const SwitchWithLabel = ({ checked, onChange }) => (
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <Switch
      checked={checked}
      onChange={onChange}
      size="small"
      color={checked ? "primary" : "default"}
    />
    <Typography
      variant="caption"
      sx={{
        color: checked ? "primary.main" : "text.secondary",
        ml: 0.5,
      }}
    >
      {checked ? "Public" : "Private"}
    </Typography>
  </Box>
);

export default PersonalDetailsCard;
